import { render } from "./NonIntegratedSuppliers.vue?vue&type=template&id=3791a618&scoped=true"
import script from "./NonIntegratedSuppliers.vue?vue&type=script&lang=js"
export * from "./NonIntegratedSuppliers.vue?vue&type=script&lang=js"

import "./NonIntegratedSuppliers.vue?vue&type=style&index=0&id=3791a618&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3791a618"]])

export default __exports__